import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'location'

  static get fields () {
    return {
      id: new UUID(),
      country: new STRING(),
      state: new STRING(),
      postcode: new STRING(),
      suburb: new STRING(),
      timezone: new STRING()
    }
  }

  static get sortables () {
    return [
      { field: 'country', label: 'Country' },
      { field: 'state', label: 'State' },
      { field: 'postcode', label: 'Postcode' },
      { field: 'suburb', label: 'Suburb' }
    ]
  }
}
